import api from '@/services/api';

export default {
  async createDocumentFolder(budgetIterationId, folderName, parentBudgetIterationDocumentId) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        folderName: folderName,
        parentBudgetIterationDocumentId: parentBudgetIterationDocumentId || null
      };
      let response = await api.post(`Budgets/${budgetIterationId}/Documents/Folders`, requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async uploadBudgetDocument(budgetIterationId, displayName, parentBudgetIterationDocumentId, file) {
    try {
      let formData = new FormData();
      formData.append('BudgetIterationId', budgetIterationId);

      if (displayName) {
        formData.append('DisplayName', displayName);
      }

      if (parentBudgetIterationDocumentId) {
        formData.append('ParentBudgetIterationDocumentId', parentBudgetIterationDocumentId);
      }
      
      formData.append('File', file);
      
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      let response = await api.post(`Budgets/${budgetIterationId}/Documents`, formData, config);

      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async getBudgetDocuments(budgetIterationId) {
    try {
      let response = await api.get(`Budgets/${budgetIterationId}/Documents`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async updateBudgetDocument(budgetIterationId, budgetIterationDocumentId, displayName, parentBudgetIterationDocumentId) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        budgetIterationDocumentId: budgetIterationDocumentId,
        displayName: displayName,
        parentBudgetIterationDocumentId: parentBudgetIterationDocumentId || null
      };
      let response = await api.put(`Budgets/${budgetIterationId}/Documents`, requestBody);
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async deleteBudgetDocument(budgetIterationId, budgetIterationDocumentId) {
    try {
      let response = await api.delete(`Budgets/${budgetIterationId}/Documents/${budgetIterationDocumentId}`);
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async getBudgetDocumentUri(budgetIterationId, budgetIterationDocumentId) {
    try {
      let response = await api.get(`Budgets/${budgetIterationId}/Documents/${budgetIterationDocumentId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
}